module.exports = __webpack_public_path__ + "img/introducePageSex_show_one.5e18066c.jpg";